import * as React from 'react';

export interface INotVisualItemProps {
  value: GQL.IAttributeValue;
}

export class NotVisualItem extends React.PureComponent<INotVisualItemProps> {
  public render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {this.props.value.title}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributeDetail/components/Values/components/NotVisualItem.tsx